/**
 * Layout Metrics Bar — shows space utilization statistics after smart layout.
 * Displays rack count, space utilization %, row count, and aisle count.
 */

import React from 'react';
import { BarChart3, X } from 'lucide-react';
import { useLayoutEditor } from '../contexts/LayoutEditorContext';

const LayoutMetricsBar: React.FC = () => {
  const { state, dispatch } = useLayoutEditor();
  const { layoutMetrics } = state;

  if (!layoutMetrics) return null;

  return (
    <div className="flex items-center gap-4 px-4 py-2 bg-blue-50 border-t border-blue-200 text-sm flex-shrink-0">
      <BarChart3 className="w-4 h-4 text-blue-600 flex-shrink-0" />
      <span className="text-blue-800 font-medium">
        {layoutMetrics.placedRacks}/{layoutMetrics.totalRacks} plassert
      </span>
      <span className="text-blue-700">
        {(layoutMetrics.spaceUtilization * 100).toFixed(0)}% utnyttelse
      </span>
      <span className="text-blue-600">
        {layoutMetrics.rowCount} rader
      </span>
      {layoutMetrics.aisleCount > 0 && (
        <span className="text-blue-600">
          {layoutMetrics.aisleCount} ganger
        </span>
      )}
      {layoutMetrics.failedRacks > 0 && (
        <span className="text-red-600 font-medium">
          {layoutMetrics.failedRacks} ikke plassert
        </span>
      )}
      <button
        onClick={() => dispatch({ type: 'CLOSE_QUICK_LAYOUT' })}
        className="ml-auto p-1 hover:bg-blue-100 rounded text-blue-400 hover:text-blue-600"
        title="Skjul metrikker"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default LayoutMetricsBar;
